import { View, StyleSheet } from "react-native";

import { Typography } from "@smartrent/ui";

import Alert from "@/common/Alert";
import { useCommunityLockdownStatus } from "@/api/group";
import { formatDateToBeHumanReadable, formatDate } from "@/utils";
import { useGroup } from "@/pages/group/GroupContext";

export const GroupAlerts = () => {
  const { group } = useGroup();
  const { data: communityLockdownAccessPoints } = useCommunityLockdownStatus(
    group.id
  );

  const isLockdownEnabled =
    communityLockdownAccessPoints?.community_lockdown_enabled;

  if (!group.deleted_at && !isLockdownEnabled) {
    return null;
  }

  return (
    <View style={styles.wrapper}>
      {isLockdownEnabled && (
        <Alert
          type="error"
          className="u-p8 u-flex u-flex-justify-center u-mbottom4"
        >
          <Typography color="textTitleInverse">
            EMERGENCY LOCKDOWN ACTIVE
          </Typography>
        </Alert>
      )}
      {group.deleted_at && (
        <Alert type="error" className="u-mbottom4">
          Group Deleted -{" "}
          {formatDateToBeHumanReadable({ date: group.deleted_at })} (
          {formatDate({ date: group.deleted_at })})
        </Alert>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: { marginBottom: 16 },
});
